import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/new-customer-subscription`;

export const getSubscriptionStatus = () => callApi({
  method: 'GET',
  endpoint: `${basePath}/get-subscription`
});

export const getSampleRecord = () => callApi({
  method: 'GET',
  endpoint: `${basePath}/get-take-sample-record`
});
